export default __webpack_public_path__ + "static/media/colorGloss_kl2.55150bc2.png";